import React from 'react';
import './SocialMedia.scss';

import twitter from './assets/rrss/twitterR.png';
import instagram from './assets/rrss/instagramR.png';
import ivoox from './assets/rrss/ivooxR.png';
import discord from './assets/rrss/discordR.png';
import youtube from './assets/rrss/youtubeR.png';
import twitch from './assets/rrss/twitchR.png';
import kofi from './assets/rrss/kofiR.png';

const SocialMedia = () => {
    return (
        <ul className={"social-media"}>
            <li className="item">
                <a href="https://www.twitch.tv/jacinmaeron" target="blank"><img className="twitch" src={twitch} alt="twitch" /></a>
            </li>
            <li className="item">
                <a href="https://youtube.com/@JacinMaeron" target="blank"><img className="youtube" src={youtube} alt="youtube" /></a>
            </li>
            <li className="item">
                <a href="https://www.instagram.com/jacinmaeron" target="blank"><img className="instagram" src={instagram} alt="instagram" /></a>
            </li>   
            <li className="item">
                <a href="https://www.ivoox.com/escuchar-jacinmaeron_nq_1423694_1.html" target="blank"><img className="ivoox" src={ivoox} alt="ivoox" /></a>
            </li>
            <li className="item">
                <a href="https://twitter.com/JacinMaeron" target="blank"><img className="twitter" src={twitter} alt="twitter" /></a>
            </li>
            <li className="item">
                <a href="https://discord.gg/A4gVanUDH9" target="blank"><img className="discord" src={discord} alt="discord" /></a>
            </li>
            <li className="item">
                <a href="https://ko-fi.com/jacinmaeron" target="blank"><img className="kofi" src={kofi} alt="kofi" /></a>
            </li>
        </ul>
    );
}



export default SocialMedia;